export default "__VITE_ASSET__DRycpuRQ__"